import { createContext } from 'react';

export const PostIDContext = createContext();
